export const referenceScreens = [
    {
        key: 'today',
        fileName: 'ChatGPT Image 2026年6月14日 13_28_54 (1).png',
        sourceFile: 'design/guanxin-ui/ChatGPT Image 2026年6月14日 13_28_54 (1).png',
        overlayName: 'today',
        implementedRoutes: ['web:/today', 'wechat:/pages/today/index'],
        notes: 'Today composition, brand header, botanical feature card, quick start rhythm, bottom ask entry. Metrics are light entry signals, not a dashboard.',
    },
    {
        key: 'topics',
        fileName: 'ChatGPT Image 2026年6月14日 13_28_54 (2).png',
        sourceFile: 'design/guanxin-ui/ChatGPT Image 2026年6月14日 13_28_54 (2).png',
        overlayName: 'topics',
        implementedRoutes: ['web:/topics', 'wechat:/pages/topics/index'],
        notes: 'Topic card hierarchy, search, filter, illustration slots, and low-noise conversation summaries.',
    },
    {
        key: 'topic-detail',
        fileName: 'ChatGPT Image 2026年6月14日 13_28_55 (4).png',
        sourceFile: 'design/guanxin-ui/ChatGPT Image 2026年6月14日 13_28_55 (4).png',
        overlayName: 'topic-detail',
        implementedRoutes: ['web:/topics/:id'],
        notes: 'Topic detail structure, hero surface, section hierarchy, and next-reflection treatment.',
    },
    {
        key: 'relationships',
        fileName: 'ChatGPT Image 2026年6月14日 13_28_56 (5).png',
        sourceFile: 'design/guanxin-ui/ChatGPT Image 2026年6月14日 13_28_56 (5).png',
        overlayName: 'relationships',
        implementedRoutes: ['web:/relationships', 'web:/relationships/:id', 'wechat:/pages/relationships/index'],
        notes: 'Relationship cards and six-axis relationship-mode map.',
    },
    {
        key: 'memory',
        fileName: 'ChatGPT Image 2026年6月14日 13_28_56 (6).png',
        sourceFile: 'design/guanxin-ui/ChatGPT Image 2026年6月14日 13_28_56 (6).png',
        overlayName: 'memory',
        implementedRoutes: ['web:/memory', 'wechat:/pages/memory/index'],
        notes: 'Segmented Notes, Memory, Insights treatment and review-card rhythm.',
    },
];
export function referenceScreenByOverlay(overlayName) {
    return referenceScreens.find((screen) => screen.overlayName === overlayName);
}
